const ww = window.innerWidth
const wh = window.innerHeight

const s2HandW = wh * 0.046 * 158 / 113

// 门位置
const s3BgW = wh * 3379 / 2436
const s2DoorX = 470 * s3BgW / 3379

const s2Talk1H = wh * 0.298
const s2Talk1W = s2Talk1H * 184 / 727

const sprites = {
  s2_cloud2: {
    size: { mode: 'heightFit', height: 0.230 },
    position: { x: 1, y: 0.16 },
    anchor: 'topLeft'
  },
  s2_cloud1: {
    size: { mode: 'heightFit', height: 0.591 },
    position: { x: 1, y: 0 },
    anchor: 'topLeft'
  },
  s2_static: {
    size: { mode: 'heightFit', height: 1 },
    position: 'topLeft',
    anchor: 'topLeft'
  },
  s2_hand: {
    size: { mode: 'heightFit', height: 0.046 },
    position: { x: (ww + s2HandW) / ww, y: 0.768 },
    anchor: 'right'
  },
  s2_people: {
    size: { mode: 'heightFit', height: 0.407 },
    position: { x: 1, y: 0.926 },
    anchor: 'bottomLeft'
  },
  s2_child: {
    key: 's2_child1',
    size: { mode: 'heightFit', height: 0.189 },
    position: { x: 1, y: 0.836 },
    anchor: 'bottomLeft'
  },
  s2_plane: {
    size: { mode: 'heightFit', height: 0.127 },
    position: { x: 0.6, y: 0.62 },
    anchor: 'bottomLeft'
  },
  s2_door: {
    size: { mode: 'heightFit', height: 0.511 },
    position: { x: s2DoorX / ww, y: 0.356 },
    anchor: 'topLeft'
  },
  s2_cloud3: {
    key: 's1_cloud2',
    size: { mode: 'heightFit', height: 0.84 },
    position: { x: 1, y: 1 },
    anchor: 'bottom'
  },
  s2_text: {
    size: { mode: 'heightFit', height: 882 / 2436 },
    position: { x: 846 / 1125, y: 370 / 2436 },
    anchor: 'topLeft'
  },
  s2_talk1: {
    size: { mode: 'heightFit', height: 0.298 },
    position: { x: 1 + s2Talk1W / ww, y: 0.72 },
    anchor: 'bottomRight'
  },
  s2_talk2: {
    size: { mode: 'heightFit', height: 0.376 },
    position: { x: 1, y: 0.6 },
    anchor: 'bottomLeft'
  }
}

export default sprites



// WEBPACK FOOTER //
// ./src/assets/scenes/s2/sprites.js